export default "__VITE_ASSET__ff9ca9b0__"